import styled from 'styled-components/macro'
import { COLORS } from 'design_system/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 15px;
  margin-left: 40px;
`

export const FormRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const FormColumn = styled.div`
  margin-right: 30px;
  width: ${(props) => props.$width};
  margin-top: ${(props) => props.$marginTop ?? ''};
`

export const StationDropItem = styled.div`
  cursor: ${(props) => (props.$isConnected ? 'pointer' : '')};
  padding: 4px;
  color: ${(props) => (props.$isConnected ? 'black' : 'gray')};
  background-color: ${(props) =>
    props.$backgroundColor ? COLORS.light_grey : ''};
`

export const Response = styled.div`
  width: 840px;
  min-height: 150px;
  height: auto;
  background-color: #f1f1f3;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
`
